import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-element display series (Full Funding peak + cost over time), computed
// server-side so no projection formulas run in the browser.
export function useElementSeries(aid, variables) {
  const [series, setSeries] = useState(null);
  const inflation = variables?.inflation_rate;
  useEffect(() => {
    if (!aid || !variables) return undefined;
    let alive = true;
    axios
      .post(`${API}/associations/${aid}/element-series`, { variables })
      .then((res) => alive && setSeries(res.data))
      .catch(() => alive && setSeries(null));
    return () => {
      alive = false;
    };
    // Only inflation affects these series.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aid, inflation]);
  return series;
}
